export default __webpack_public_path__ + "static/media/commingSoonEn.f0b0ccfa.png";